import React, { useRef } from 'react';

const FormError = ({ field, defaultValue }: { field: {message?: string} | undefined, defaultValue: string }) => {
  const message = useRef<string>();

  if(field && message.current !== field.message) {
    message.current = field?.message || defaultValue;
  }

  return <p className='error'>{ message.current }</p>;
};

export default FormError;
